/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import {
  Layout,
  Card,
  Table,
  Button,
  Space,
  Switch,
  Popconfirm,
  Input,
  Tag,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { getAPI, postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import {
  APP_PAGE_LIST,
  APP_PAGE_TOGGLE,
  APP_PAGE_DELETE,
} from "../../constants/api";

function AppPageTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    getAPI(
      APP_PAGE_LIST,
      (res) => {
        if (res.status) {
          setData(res.data);
          setFilteredData(res.data);
        } else {
          setData([]);
          setFilteredData([]);
        }
        setLoading(false);
      },
      () => setLoading(false)
    );
  };

  const toggleStatus = (row, checked) => {
    postAPI(
      APP_PAGE_TOGGLE,
      { id: row.id, is_enabled: checked },
      (res) => {
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => displayMessage(ERROR_MSG_TYPE, "Unable to update status")
    );
  };

  const deletePage = (id) => {
    postAPI(
      APP_PAGE_DELETE,
      { id },
      (res) => {
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => displayMessage(ERROR_MSG_TYPE, "Unable to delete page")
    );
  };

  const handleSearch = (value) => {
    setSearch(value);
    const filtered = data.filter(
      (row) =>
        row.title.toLowerCase().includes(value.toLowerCase()) ||
        row.route.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 200,
    },
    {
      title: "Route",
      dataIndex: "route",
      width: 250,
    },
    {
      title: "Status",
      width: 120,
      render: (_, row) => (
        <Space>
          <Switch
            checked={row.is_enabled}
            onChange={(checked) => toggleStatus(row, checked)}
          />
          {row.is_enabled ? (
            <Tag color="green">Enabled</Tag>
          ) : (
            <Tag color="red">Disabled</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Action",
      width: 150,
      render: (_, row) => (
        <Popconfirm
          title="Delete Page"
          description="Are you sure to delete this page?"
          onConfirm={() => deletePage(row.id)}
        >
          <Button danger size="small">
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Application Pages Control"
          extra={
            <Space>
              <Input
                placeholder="Search title / route"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 250 }}
              />
              <Button type="primary" onClick={() => navigate("/app-pages/add")}>
                Add Page <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredData}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default AppPageTable;
